import { render, staticRenderFns } from "./ScenarioSwitch.vue?vue&type=template&id=f4676f34&scoped=true"
import script from "./ScenarioSwitch.vue?vue&type=script&lang=js"
export * from "./ScenarioSwitch.vue?vue&type=script&lang=js"
import style0 from "./ScenarioSwitch.vue?vue&type=style&index=0&id=f4676f34&prod&lang=scss"
import style1 from "./ScenarioSwitch.vue?vue&type=style&index=1&id=f4676f34&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4676f34",
  null
  
)

export default component.exports